import React from 'react'
import context from '@/context'
import { BsrsGrid, commandColumnProps, EnumCell } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid'

const DashboardList = ({ dashboard, localize, enumName, saveDashboardItem, deleteDashboardItem }) => {
  const handleItemEdited = (e) => saveDashboardItem(e.item)
  const handleItemDeleted = (item) => deleteDashboardItem(item.id)

  return (
    <BsrsGrid
      dataSource={context.api.dashboardService.getUsersTableData}
      filterable={false}
      editable
      sortable={false}
      onItemEdited={handleItemEdited}
      lastReloadedAt={dashboard.componentKey} >
      <Column field='widgetType' title={localize('Common.Name')} editable={false} cell={EnumCell({ localize, enumName })} enumName={enumName} />
      <Column field='rowsCount' title={localize('Common.RowsCount')} width='150px' editable editor='numeric' />
      <Column field='order' title={localize('Common.Order')} width='150px' editable editor='numeric' />
      <Column {...commandColumnProps({
        deleteAction: handleItemDeleted,
        localize
      })} />
    </BsrsGrid>
  )
}

export default DashboardList



// WEBPACK FOOTER //
// ./src/components/dashboard/settings/list.js